import Shipping from '../src/Shipping/index.tsx';
export default Shipping;
